import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

import { ListGroup } from "@/ui";
import { MatchHistoryRow } from "@/features/matches/MatchHistoryRow";
import { useMyMatches } from "@/features/queries";
import { PaginationBar } from "./PaginationBar";

const PER_PAGE = 20;

export function ProfileMatchesPage() {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  // Over-fetch by 1 to learn whether a next page exists.
  const matches = useMyMatches(PER_PAGE + 1, page * PER_PAGE);

  const items = (matches.data ?? []).slice(0, PER_PAGE);
  const hasNext = (matches.data ?? []).length > PER_PAGE;

  return (
    <div style={{ paddingBottom: 24 }}>
      <BackHeader title="Последние матчи" onBack={() => navigate("/profile")} />

      {matches.isLoading ? (
        <div className="body" style={{ padding: 16 }}>Загрузка…</div>
      ) : items.length === 0 ? (
        <div
          style={{
            background: "var(--bg-section)",
            borderRadius: "var(--r-lg)",
            margin: "0 16px",
            padding: 20,
            textAlign: "center",
            color: "var(--fg2)",
          }}
        >
          {page === 0 ? "Здесь появятся твои матчи." : "Больше матчей нет."}
        </div>
      ) : (
        <ListGroup>
          {items.map((m) => <MatchHistoryRow key={m.id} match={m} />)}
        </ListGroup>
      )}

      <PaginationBar page={page} hasNext={hasNext} onPageChange={setPage} />
    </div>
  );
}

function BackHeader({ title, onBack }: { title: string; onBack: () => void }) {
  return (
    <div style={{ padding: "16px" }}>
      <button
        type="button"
        onClick={onBack}
        style={{
          background: "transparent",
          border: 0,
          color: "var(--fg2)",
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: 0,
          marginBottom: 8,
          fontFamily: "var(--font-body)",
          fontSize: 13,
        }}
      >
        <ArrowLeft size={14} /> назад
      </button>
      <h1 className="h1" style={{ margin: 0 }}>{title}</h1>
    </div>
  );
}
